export const LABELS = {
  TITLE: 'Application drafts',
  NO_DRAFTS: 'No drafts to show.',
  CREATE_NEW: 'Create new',
};
